import type { WikiPageSummaryDTO } from "../../common/api/types.js";

export interface WikiTreeNode extends WikiPageSummaryDTO {
  children: WikiTreeNode[];
}

export function buildWikiTree(pages: readonly WikiPageSummaryDTO[]): WikiTreeNode[] {
  const byId = new Map(pages.map((page) => [page.id, { ...page, children: [] as WikiTreeNode[] }]));
  const roots: WikiTreeNode[] = [];

  for (const node of byId.values()) {
    const parent = node.parentId ? byId.get(node.parentId) : null;
    if (parent && parent.id !== node.id) parent.children.push(node);
    else roots.push(node);
  }

  const sort = (entries: WikiTreeNode[], ancestors = new Set<string>()): WikiTreeNode[] => entries
    .filter((entry) => !ancestors.has(entry.id))
    .sort((left, right) => left.position - right.position || left.title.localeCompare(right.title, "de"))
    .map((entry) => ({
      ...entry,
      children: sort(entry.children, new Set([...ancestors, entry.id])),
    }));

  return sort(roots);
}

